<button mat-icon-button [matMenuTriggerFor]="notificationmenu" (menuOpened)="onMenuOpened()" [attr.aria-label]="'notifications.title' | translate" class="m-x-5">
  <i-tabler class="d-flex bell-icon" name="bell" [matBadge]="badgeValue" [matBadgeHidden]="!unreadCount" matBadgeColor="primary"></i-tabler>
</button>
<mat-menu #notificationmenu="matMenu" [xPosition]="xPosition" class="topbar-dd cardWithShadow">
  <div class="d-flex align-items-center p-x-32 p-y-16">
    <h6 class="f-s-16 f-w-600 m-0">{{ 'notifications.title' | translate }}</h6>
    @if (unreadCount) {
    <span class="m-l-auto">
      <span class="bg-primary text-white p-x-8 p-y-4 f-w-500 rounded f-s-12">{{ 'notifications.newCount' | translate: { count: unreadCount } }}</span>
    </span>
    }
  </div>

  @if (isLoading) {
  <div class="p-x-32 p-y-16 d-flex justify-content-center">
    <mat-spinner diameter="28"></mat-spinner>
  </div>
  } @else if (hasError) {
  <div class="p-x-32 p-y-16">
    <p class="f-s-14 m-b-8">{{ 'notifications.loadError' | translate }}</p>
    <button mat-stroked-button color="primary" (click)="$event.stopPropagation(); loadLatest()">{{ 'notifications.retry' | translate }}</button>
  </div>
  } @else if (!latest.length) {
  <div class="p-x-32 p-y-16">
    <span class="f-s-14">{{ 'notifications.empty' | translate }}</span>
  </div>
  } @else if (translationsReady) {
    @for (notification of latest; track notification._id) {
    <button mat-menu-item class="p-x-32 p-y-16" (click)="open(notification)" [class.bg-light-primary]="!notification.isRead"
      [attr.aria-label]="(notification.isRead ? '' : ('notifications.unread' | translate) + ': ') + text(notification).title">
      <div class="d-flex align-items-center">
        <i-tabler class="d-flex" [name]="notification.isRead ? 'bell' : 'bell-ringing'"></i-tabler>
        <div class="m-l-16">
          <h5 class="f-s-14 m-0" [class.f-w-600]="!notification.isRead"> {{ text(notification).title }} </h5>
          <span class="d-block">{{ text(notification).message }}</span>
          <span class="d-block f-s-12">{{ getDateFormat(notification.createdAt) }}</span>
        </div>
        @if (!notification.isRead) {
        <span class="bg-primary rounded-circle m-l-16" style="width: 8px; height: 8px; display: inline-block;" aria-hidden="true"></span>
        }
      </div>
    </button>
    }
  }

  <div class="p-y-12 p-x-32">
    <a mat-stroked-button color="primary" class="w-100" routerLink="/notifications">{{ 'notifications.seeAll' | translate }}</a>
  </div>
</mat-menu>
